import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ReceptionPoint')
export class QRReceptionPoint552 {
  @JsonProperty('Code', String)
  public Code: string | undefined = undefined;
  @JsonProperty('City', String)
  public City: string | undefined = undefined;
  @JsonProperty('Country', String)
  public Country: string | undefined = undefined;
}

@JsonObject('Cause')
export class QRCause552 {
  @JsonProperty('CommandId', Number)
  public Id: number | undefined = undefined;
  @JsonProperty('Text', String)
  public Text: string | undefined = undefined;
}

@JsonObject('Goal')
export class QRGoal552 {
  @JsonProperty('Id', Number)
  public Id: number | undefined = undefined;
  @JsonProperty('Text', String)
  public Text: string | undefined = undefined;
}

@JsonObject('PersonAddress')
export class QRPersonAddress552 {
  @JsonProperty('1', String)
  public Index: string | undefined = undefined;
  @JsonProperty('2', String)
  public Country: string | undefined = undefined;
  @JsonProperty('3', String)
  public AdmDivision: string | undefined = undefined;
  @JsonProperty('4', String)
  public Settlement: string | undefined = undefined;
  @JsonProperty('5', String)
  public Street: string | undefined = undefined;
  @JsonProperty('6', String)
  public Building: string | undefined = undefined;
  @JsonProperty('7', String)
  public Housing: string | undefined = undefined;
  @JsonProperty('8', String)
  public Structure: string | undefined = undefined;
  @JsonProperty('9', String)
  public Flat: string | undefined = undefined;
}

@JsonObject('NameChange')
export class QRNameChange552 {
  @JsonProperty('1', String)
  public FirstName: string | undefined = undefined;
  @JsonProperty('2', String)
  public MiddleName: string | undefined = undefined;
  @JsonProperty('3', String)
  public LastName: string | undefined = undefined;
  @JsonProperty('4', String)
  public ChangeDate: string | undefined = undefined;
  @JsonProperty('5', String)
  public Location: string | undefined = undefined;
}

@JsonObject('JobRecord')
export class QRJobRecord552 {
  @JsonProperty('1', String)
  public Job: string | undefined = undefined;
  @JsonProperty('2', String)
  public Address: string | undefined = undefined;
  @JsonProperty('3', String)
  public DateFrom: string | undefined = undefined;
  @JsonProperty('4', String)
  public DateTo: string | undefined = undefined;
}

@JsonObject('IdentityDocumentType')
export class QRIdentityDocumentType552 {
  @JsonProperty('Id', Number)
  public Id: number | undefined = undefined;
  @JsonProperty('Text', String)
  public Text: string | undefined = undefined;
}

@JsonObject('IdentityDocument')
export class QRIdentityDocument552 {
  @JsonProperty('IssueDate', String)
  public IssueDate: string | undefined = undefined;
  @JsonProperty('Issuer', String)
  public Issuer: string | undefined = undefined;
  @JsonProperty('Number', String)
  public Number: string | undefined = undefined;
  @JsonProperty('Series', String)
  public Series: string | undefined = undefined;
  @JsonProperty('Type', QRIdentityDocumentType552)
  public Type: QRIdentityDocumentType552 | undefined = undefined;
}

@JsonObject('Gender')
export class QRGender552 {
  @JsonProperty('Id', Number)
  public Id: number | undefined = undefined;
  @JsonProperty('Text', String)
  public Text: string | undefined = undefined;
}

@JsonObject('ForeignPassport')
export class QRForeignPasport552 {
  @JsonProperty('2', String)
  public Series: string | undefined = undefined;
  @JsonProperty('3', String)
  public Number: string | undefined = undefined;
  @JsonProperty('4', String)
  public IssueDate: string | undefined = undefined;
  @JsonProperty('6', String)
  public Issuer: string | undefined = undefined;
  @JsonProperty('12', Boolean)
  public MustBeCanceled: boolean | undefined = undefined;
}

@JsonObject('Person')
export class QRPerson552 {
  @JsonProperty('1', String)
  public FirstName: string | undefined = undefined;
  @JsonProperty('2', String)
  public MiddleName: string | undefined = undefined;
  @JsonProperty('3', String)
  public LastName: string | undefined = undefined;
  @JsonProperty('4', String)
  public FirstNameLat: string | undefined = undefined;
  @JsonProperty('5', String)
  public LastNameLat: string | undefined = undefined;
  @JsonProperty('8', String)
  public SecondNationality: string | undefined = undefined;
  @JsonProperty('9', String)
  public BirthPlaceRus: string | undefined = undefined;
  @JsonProperty('10', String)
  public BirthPlaceLat: string | undefined = undefined;
  @JsonProperty('11', String)
  public Birthdate: string | undefined = undefined;
  @JsonProperty('12', QRGender552)
  public Gender: QRGender552 | undefined = undefined;
  @JsonProperty('13', String)
  public PermAddressStr: string | undefined = undefined;
  @JsonProperty('14', String)
  public PermPhoneStr: string | undefined = undefined;
  @JsonProperty('15', String)
  public TempAddressStr: string | undefined = undefined;
  @JsonProperty('16', String)
  public TempPhoneStr: string | undefined = undefined;
  @JsonProperty('17', [QRForeignPasport552])
  public ForeignPassports: QRForeignPasport552[] | undefined = undefined;
  @JsonProperty('18', [QRNameChange552])
  public NameChanges: QRNameChange552[] | undefined = undefined;
  @JsonProperty('19', QRIdentityDocument552)
  public IdentityDocument: QRIdentityDocument552 | undefined = undefined;
  @JsonProperty('20', [QRJobRecord552])
  public JobHistory: QRJobRecord552[] | undefined = undefined;
  @JsonProperty('25', String)
  public BirthPlaceFull: string | undefined = undefined;
  @JsonProperty('26', Number)
  public BirthDateCompleteness: number | undefined = undefined;
  @JsonProperty('32', QRPersonAddress552)
  public PermAddress: QRPersonAddress552 | undefined = undefined;
  @JsonProperty('33', QRPersonAddress552)
  public TempAddress: QRPersonAddress552 | undefined = undefined;
}

@JsonObject('MailingInfo')
export class QRMailingInfo552 {
  @JsonProperty('1', Boolean)
  public Active: boolean | undefined = undefined;
  @JsonProperty('5', String)
  public AddressRus: string | undefined = undefined;
  @JsonProperty('6', String)
  public AddressLat: string | undefined = undefined;
}

@JsonObject('SourceInfo')
export class QRSourceInfo552 {
  @JsonProperty('WebSiteVersion', String)
  public WebSiteVersion: string | undefined = undefined;
}

@JsonObject('Application')
export class QRApplication552 {
  @JsonProperty('1', QRCause552)
  public Cause: QRCause552 | undefined = undefined;
  @JsonProperty('2', QRGoal552)
  public Goal: QRGoal552 | undefined = undefined;
  @JsonProperty('3', QRPerson552)
  public Person: QRPerson552 = new QRPerson552();
  @JsonProperty('4', QRPerson552)
  public ChildRepresentative: QRPerson552 | undefined = undefined;
  @JsonProperty('6', String)
  public SecretAccess: string | undefined = undefined;
  @JsonProperty('7', String)
  public DepartureRestrictions: string | undefined = undefined;
  @JsonProperty('8', String)
  public MilitaryService: string | undefined = undefined;
  @JsonProperty('9', String)
  public Conviction: string | undefined = undefined;
  @JsonProperty('10', String)
  public LegalObligations: string | undefined = undefined;
  @JsonProperty('11', String)
  public ResidenceCountry: string | undefined = undefined;
  @JsonProperty('12', String)
  public JobDate: string | undefined = undefined;
  @JsonProperty('13', String)
  public JobMan: string | undefined = undefined;
  @JsonProperty('15', String)
  public ApplicantDate: string | undefined = undefined;
  @JsonProperty('SourceInfo', QRSourceInfo552)
  public SourceInfo: QRSourceInfo552 | undefined = undefined;
}

@JsonObject('Req')
export class QRReq552 {
  @JsonProperty('3', QRReceptionPoint552)
  public ReceptionPoint: QRReceptionPoint552 | undefined = undefined;
  @JsonProperty('4', QRApplication552)
  public Application: QRApplication552 = new QRApplication552();
  @JsonProperty('11', QRMailingInfo552)
  public MailPass: QRMailingInfo552 | undefined = undefined;
}
